import { FC } from 'react';
import { StepsHeader } from './StepsHeader/StepsHeader';
import { StepContent } from './StepContent/StepContent';
import { useSingleCourse } from '../../contexts/SingleCourseProvider';
import { Loader } from '@new/common/ui/Loader/Loader';

export const CourseCompletionSteps: FC = () => {
  const { course } = useSingleCourse();

  if (!course) {
    return <Loader />;
  }

  return (
    <div className="flex flex-col gap-7 bg-(--neutral-white-NW1000) border-2 border-(--neutral-black-NB100) rounded-3xl! p-5 shadow-sm">
      <h3 className="[font-size:var(--fs-h6)]! lg:[font-size:var(--fs-h5)]! text-(--neutral-black-NB900)! font-bold m-0!">
        Course Completion Steps
      </h3>
      <StepsHeader />
      <StepContent />
    </div>
  );
};
